export default __webpack_public_path__ + "static/media/face-8.59ee5e23.jpg";